import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() loading: boolean = false;
  @Input() message: string = 'Loading...';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() overlay: boolean = true;
  @Input() fullScreen: boolean = false;
  @Input() backdrop: boolean = true;

  // Computed size values
  get spinnerSize(): number {
    switch (this.size) {
      case 'small': return 40;
      case 'medium': return 60;
      case 'large': return 80;
      default: return 60;
    }
  }

  get strokeWidth(): number {
    switch (this.size) {
      case 'small': return 3;
      case 'medium': return 4;
      case 'large': return 5;
      default: return 4;
    }
  }
}

